export enum OPERATION {
  UserBalance = 'UserBalance',
  GetStripeRedirectUrl = 'GetStripeRedirectUrl',
  GetPaymentConfigurations = 'GetPaymentConfigurations',
  GetBrainTreeClientToken = 'GetBrainTreeClientToken',
  GetXenditInvoiceURL = 'GetXenditInvoiceURL',
  GetMonerisTicket = 'GetMonerisTicket',
  GetAuthorizeNetClientToken = 'GetAuthorizeNetClientToken',
  GetHeartlandHash = 'GetHeartlandHash',
  GetNayaxCheckout = 'GetNayaxCheckout',
  DeleteFile = 'DeleteFile',
  GetEGHLHash = 'getEghlHash',
};


export const GET_BALANCE = `query UserBalance {
  userBalance {
      AccountName
      Balance
      GroupID
  }
}`;

export const GET_STRIPE_REDIRECT_URL = `
query GetStripeRedirectUrl($stripeInput: StripeCheckoutInput) {
  getStripeRedirectUrl(stripeInput: $stripeInput) {
    message
    statusCode
  }
}`;

export const GET_PAYMENT_CONFIGURATION = `
query GetPaymentConfigurations($paginationInput: PaginationData, $customerIds: [ID]) {
  getPaymentConfigurations(paginationInput: $paginationInput, customerIds: $customerIds) {
    payment {
      _id
      CustomerID
      PaymentType
      PaymentName
      Stripe {
        SecretKey
        PublicKey
      }
    
    }
  }
}`;

export const GET_BRAINTREE_TOKEN = `
query GetBrainTreeClientToken($braintreeTokenInput: BraintreeTokenInput) {
  getBrainTreeClientToken(braintreeTokenInput: $braintreeTokenInput) {
    StatusCode
    Message
    Token
  }
 }`;

export const GET_XENDIT_INVOICE_URL = `
 query GetXenditInvoiceURL($xenditInvoiceInput: XenditInvoiceInput) {
  getXenditInvoiceURL(xenditInvoiceInput: $xenditInvoiceInput) {
    StatusCode
    PayURL
    Message
  }
}`;

export const GET_MONERIS_TICKET = `
query GetMonerisTicket($monerisCheckoutInput: MonerisCheckoutInput) {
  getMonerisTicket(monerisCheckoutInput: $monerisCheckoutInput) {
    Message
    StatusCode
    Ticket
  }
}`;

export const GET_AUTHORIZE_NET_TOKEN = `
query GetAuthorizeNetClientToken($authorizeNetInput: AuthorizeNetTokenInput) {
 getAuthorizeNetClientToken(authorizeNetInput: $authorizeNetInput) {
   token
   statusCode
   message
 }
}`;

export const GET_HEARTLAND_HASH = `
query GetHeartlandHash($heartlandHashInput: HeartlandHashInput) {
  getHeartlandHash(heartlandHashInput: $heartlandHashInput) {
    Hash
    Message
    OrderID
    StatusCode
    Timestamp
    MerchantID
    Currency
    Amount
  }
}`;

export const GET_NAYAX_CHECKOUT = `
query GetNayaxCheckout($nayaxCheckoutInput: NayaxCheckoutInput) {
  getNayaxCheckout(nayaxCheckoutInput: $nayaxCheckoutInput) {
    Message
    StatusCode
    TransactionID
  }
}`;

export const GET_EGHL_HASH = `
query getEghlHash($eGHLHashInput: eGHLHashInput) {
  getEghlHash(eGHLHashInput: $eGHLHashInput) {
    ServiceID
    Message
    StatusCode
    OrderNumber
    PaymentID
    PageTimeout
    Amount
    CurrencyCode
    Hash
    CallbackURL
    ReturnURL
    UnApprovalURL
    ApprovalURL
  }
}`;
